(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nb-cart-upsell'))customElements.define('nb-cart-upsell',class extends HTMLElement{connectedCallback(){this.onclick=e=>{const b=e.target.closest('[data-nb-step]');if(!b)return;const t=this.querySelector('.nb-cart-upsell__track');t.scrollBy({left:Number(b.dataset.nbStep)*t.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};}});
  } catch(e) { console.error(e); }
})();

})();
